import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

import { useRoutes, useIsMobileLayout } from '../../hooks';
import { applicationSelectors } from '../../redux/selectors';

import EnrollQuestionnaireForm from './EnrollQuestionnaireForm.public';
import PublicQuestionnairePage from './QuestionnairePage.public';

import LayoutWithHeader from '../../containers/Layouts/LayoutWithHeader';

import Box from '../../components/Styled/Box';

const RespondentRole = React.lazy(() => import('../Home/RespondentPages/RespondentRole'));

const PublicLinkRoutes = () => {
  const routes = useRoutes();
  const isMobile = useIsMobileLayout();

  const paddingFormTop = isMobile ? '60px' : '108px';
  const paddingFormBottom = isMobile ? '40px' : '108px';

  const currentApplication = useSelector(applicationSelectors.currentApplication);

  return (
    <Switch>
      <Route
        path={[
          routes.public.questionnaire,
          routes.public.enrollQuestionnaire,
          routes.public.role,
        ]}
      >
        <LayoutWithHeader>
          <Route
            path={routes.public.enrollQuestionnaire}
            render={(routerProps) => (
              <Box pt={paddingFormTop} pb={paddingFormBottom} display='flex' justifyContent='center'>
                <EnrollQuestionnaireForm
                  {...routerProps}
                />
              </Box>
            )}
          />

          <Route
            path={routes.public.questionnaire}
            render={(routerProps) => (
              <Box display='flex' justifyContent='center'>
                <PublicQuestionnairePage
                  {...routerProps}
                />
              </Box>
            )}
          />

          <Route
            path={routes.public.role}
            render={(routerProps) => (
              <RespondentRole isPublic {...routerProps} />
            )}
          />
        </LayoutWithHeader>
      </Route>

      {
        isEmpty(currentApplication)
          ? <Redirect to={routes.start} />
          : <Redirect to={routes.public.role} />
      }

    </Switch>
  );
};

PublicLinkRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default PublicLinkRoutes;
